export function formatResolvedPartTypes(resolvedPartTypes = []) {
    return resolvedPartTypes
        .map((pt) => {
            // if leaf is true then there will never be resolved part type nodes
            if (!pt.leaf && pt.resolvedPartTypeNodes?.length) {
                pt.resolvedPartTypeNodes.forEach((resolvedPt) => {
                    if (pt.selectedFacets) resolvedPt.selectedFacets = pt.selectedFacets;
                });
                return pt.resolvedPartTypeNodes;
            }
            return [pt];
        })
        .flat();
}

export function getCostPrice(product, useExtended) {
    const { itemCost, costExtended, partPriceAvailabilityResponse = {} } = product;
    let costPrice = itemCost;

    if (useExtended) {
        costPrice = costExtended;
    } else if (!costPrice && partPriceAvailabilityResponse.price) {
        costPrice = partPriceAvailabilityResponse.price.itemCost;
    }

    return costPrice || 0;
}

export function getListPrice(product, useExtended) {
    const { customerPrice, priceExtended, partPriceAvailabilityResponse = {} } = product;
    let listPrice = customerPrice;

    if (useExtended) {
        listPrice = priceExtended;
    } else if (!listPrice && partPriceAvailabilityResponse.price) {
        ({ listPrice } = partPriceAvailabilityResponse.price);
    }

    return listPrice || 0;
}
